import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'

// Lazy load ALL route components for code splitting including Login
const Login = lazy(() => import('../pages/Login'))
const Dashboard = lazy(() => import('../pages/Dashboard'))
const NewLead = lazy(() => import('../pages/NewLead'))
const LoanProcess = lazy(() => import('../pages/LoanProcess'))
const ClientDetail = lazy(() => import('../pages/ClientDetail'))
const ITAdmin = lazy(() => import('../pages/ITAdmin'))
const Reports = lazy(() => import('../pages/Reports'))
const MangoFinanceCredit = lazy(() => import('../components/MangoFinanceCredit/MangoFinanceCredit.jsx'))
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'))

// Loading fallback component
const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      fontSize: '18px',
    }}
  >
    Loading...
  </div>
)

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/credit" 
            element={
              <ProtectedRoute>
                <MangoFinanceCredit />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/leads/new" 
            element={
              <ProtectedRoute>
                <NewLead />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/loan-process" 
            element={
              <ProtectedRoute>
                <LoanProcess />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/client-detail" 
            element={
              <ProtectedRoute>
                <ClientDetail />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/it-admin" 
            element={
              <ProtectedRoute>
                <ITAdmin />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reports" 
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } 
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default AppRouter

